import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { UserNotificationResponse } from '@1po/1po-bff-fe-spec/generated/user/response/UserNotificationResponse';
import styled from 'styled-components';
import { CircleCrossIcon } from 'assets/icons';
import StopPropagation from 'components/StopPropagation/StopPropagation';
import { mapNotificationToType } from 'components/UserNotifications/notificationsUtils';
import { cancelNotificationRequest, getUserRights } from 'domains/user';
import { Flex, Icon, Text } from 'UI';
import { getData } from 'utils';

const SFlex = styled(Flex)`
  cursor: pointer;
`;

const Notification = ({ notification }: { notification: UserNotificationResponse }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const userRoles = getData(useSelector(getUserRights)) ?? [];
  const notificationData = mapNotificationToType(t, notification, userRoles);

  const cancelNotification = () => {
    if (notification.notificationId) {
      dispatch(cancelNotificationRequest({ notificationId: notification.notificationId }));
    }
  };

  const handleRedirectFromNotification = () => {
    if (notificationData?.link && !notificationData?.disableLink) {
      history.push(notificationData.link);
      cancelNotification();
    }
  };

  return (
    <SFlex
      align={'center'}
      gap={20}
      onClick={handleRedirectFromNotification}
      data-cy={'tab-notifications-notification'}
    >
      {notificationData?.icon ?? ''}
      <Flex direction={'column'}>
        <Text type="base" bold>
          {notificationData?.title ?? ''}
        </Text>
        {notificationData?.description}
      </Flex>
      <StopPropagation>
        <Icon
          IconComponent={CircleCrossIcon}
          size={25}
          onClick={cancelNotification}
          data-cy={'tab-notifications-notification-cross'}
        />
      </StopPropagation>
    </SFlex>
  );
};

export default Notification;
